import { Footer } from "./Footer";
import { NavBarComponent } from "./NavBar";

export const PublicLayout = ({ children }: any) => {
    return (
        <div className="App">
            <NavBarComponent />
            {children}
            <Footer />
        </div>
    );
}
